<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17.857 11.5a2.357 2.357 0 1 0-2.357 2.357V17a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11v-3.143a2.357 2.357 0 0 0 2.357-2.357"/>
</svg>
